
export const handleAdminStaffSearch = (e: any, setSearchQuery: Function, navigate: Function) => {
    if (e?.target?.value?.length > 2) {
        navigate('/admin/of')
        setSearchQuery(e?.target?.value)
    }
    else {
        setSearchQuery('')
    }
}